import styles from "./styles.module.scss";
import React, { FunctionComponent } from "react";
import { Card, CardActionArea, Stack, useTheme } from "@mui/material";
import { Icon, IconType } from "../../../../icons";
import { IAlbumType } from "../../../../hooks/albumTypes";

export const AlbumTypeCard: FunctionComponent<IAlbumTypeCardProps> = ({
  albumType,
  selected,
  onClick,
  onContextMenu
}) => {
  const theme = useTheme();
  return (
    <Card sx={{ height: 64, borderRadius: "20px" }} elevation={5}>
      <CardActionArea
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "row"
        }}
        style={{
          borderColor: theme.palette.colors?.highlightBorder,
          borderWidth: 4,
          borderStyle: selected ? "double" : "none"
        }}
        onClick={onClick}
        onContextMenu={onContextMenu}
      >
        <Card className={styles.defaultIcon}>
          <Icon type={IconType.Album} />
        </Card>
        <Stack className={styles.rightContainer} spacing={1}>
          <p className={styles.name}>{albumType.name}</p>
        </Stack>
      </CardActionArea>
    </Card>
  );
};

export interface IAlbumTypeCardProps {
  albumType: IAlbumType;
  selected?: boolean;
  onClick: () => void;
  onContextMenu: (event: React.MouseEvent) => void;
}
